/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_Lower_CaseInputs */



/**
* | output |
* | --- |
* | "Text to Lower Case" |
*
* @param {Text_To_Lower_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_lower_case = /** @type {((inputs?: Text_To_Lower_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_Lower_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte en minuscules")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text in Kleinbuchstaben umwandeln")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo in minuscolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст в нижнем регистре")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto a minúsculas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本转换为小写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを小文字にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को लोअर केस में बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto para minúsculas")
	return /** @type {LocalizedString} */ ("Text to Lower Case")
});